import { lazy } from "react"
import { OysterRouter } from "~/router/type"
import { LazyLoadingSuspenseWithErrorBoundary } from "@oysterhr/feature-components"

const AdminPayrollEntityPage = lazy(
  () => import("./pages/AdminPayrollEntityPage/AdminPayrollEntityPage"),
)

const AdminPayrollEntityDetailsPage = lazy(
  () => import("./pages/AdminPayrollEntityDetailsPage/AdminPayrollEntityDetailsPage"),
)

export const staffGlobalPayrollRoutes: OysterRouter = {
  DeprecatedLeftSidebar: [
    {
      path: "vendors/entity/new",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <AdminPayrollEntityPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
    {
      path: "payroll-entity/:strongId",
      element: (
        <LazyLoadingSuspenseWithErrorBoundary fallback={null}>
          <AdminPayrollEntityDetailsPage />
        </LazyLoadingSuspenseWithErrorBoundary>
      ),
    },
  ],
  DeprecatedFullScreen: [],
}
